module.exports = __webpack_public_path__ + "media/metronic/_theme/media/bg/bg-9-458f09583a8d3ec1d9e1b8fa992a72b0.jpg";